/*
 * actions.js
 *
 * Description: Holds global Actions (for store).
 *
 * This file is part of: "http://apps.sundair.com/", "SunCrew2"
 * Copyright 2018,2019,2020 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
// demo
export const updateValue = ({ commit }, payload) => {
    commit('updateValue', payload);
};

export const action2 = () => { };

